;
(function(){
  function initRevArrows(vp){
    var track = vp.querySelector('.v9-rev__track');
    var prev  = vp.querySelector('.v9-rev__nav--prev');
    var next  = vp.querySelector('.v9-rev__nav--next');
    if(!track||!prev||!next) return;
    function step(){
      var card = track.querySelector('.v9-rev__card');
      if(!card) return Math.round(track.clientWidth*0.8);
      var gap = parseInt(getComputedStyle(track).columnGap||getComputedStyle(track).gap||'14',10);
      if(isNaN(gap)) gap = 14;
      return card.getBoundingClientRect().width + gap;
    }
    function update(){
      var max = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= max;
    }
    prev.addEventListener('click',function(){track.scrollBy({left:-step(),behavior:'smooth'});});
    next.addEventListener('click',function(){track.scrollBy({left: step(),behavior:'smooth'});});
    track.addEventListener('scroll',function(){window.requestAnimationFrame(update);},{passive:true});
    window.addEventListener('resize',update);
    update();
  }
  function boot(){
    var vps = document.querySelectorAll('.v9-rev__viewport');
    for(var i=0;i<vps.length;i++) initRevArrows(vps[i]);
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
})();
